import type { TPlainObject } from '@flatbiz/utils';
import { fbaUtils } from '../fba-utils/fba-utils.js';
import { useLocalLoadingCtx } from './context.js';
import { LocalLoadingInner } from './local-loading.jsx';

/**
 * 局部加载，包含接口数据处理逻辑
 * ```
 * 包括
 * 1. loading显示效果、error显示效果、获取服务数据
 * 2. 当 serviceConfig.params 值与上一次值不相等时，会主动发起服务调用
 * 3. 通过 serviceConfig.requiredParamsKeys 设置服务调用必填字段
 * 4. 通过 ref.onRequest 可主动发起服务调用
 * 5. 子组件通过下面方式主动发起服务调用
 *    const localLoadingApi = LocalLoading.useLocalLoading();
 *    localLoadingApi.onRequest();
 * 6. 如果内部需要滚动条，可设置 contentScroll = true （外部有高度或者设置style.height 才能生效）
 * ```
 */
export const LocalLoading = fbaUtils.attachPropertiesToComponent(
  LocalLoadingInner,
  {
    useLocalLoading: () => {
      const ctx = useLocalLoadingCtx();
      return {
        onRequest: (params?: TPlainObject) => {
          ctx.onRequest(params);
        },
      };
    },
  }
);
